import i18n from "@microdoing/shared/i18n";
import { Alert, Linking } from "react-native";
import { openSettings } from "react-native-permissions";

const AsyncAlert = async ({ alertMessage }) =>
  new Promise(resolve => {
    Alert.alert(
      i18n.t("alert-ask-permission-title"),
      alertMessage,
      [
        {
          text: i18n.t("Cancel"),
          onPress: () => {
            resolve(false);
          },
          style: "cancel",
        },
        {
          text: i18n.t("Activate"),
          onPress: async () => {
            await openSettings();
            resolve(true);
          },
        },
      ],
      { cancelable: false },
    );
  });

const askPermissionAgain = async ({ alertMessage }) => {
  return AsyncAlert({ alertMessage });
};

export default askPermissionAgain;
